import { makeStyles, Theme } from '@material-ui/core/styles'

export const useClasses = makeStyles((theme: Theme) => ({
  toolbarContainer: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5),
      paddingLeft: theme.spacing(10),
    },
  },
  plateNumberFieldWrapper: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: 300,
    },
  },
  zoneFieldWrapper: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: 200,
    },
  },
  listTitle: {
    marginBottom: 20,
  },
  plateNumberHelperIcon: {
    height: 16,
    verticalAlign: 'middle',
    marginTop: -2,
    marginRight: 2,
  },
  plateNumberHelperIconSuccess: {
    color: theme.palette.success.main,
  },
  plateNumberHelperIconWarning: {
    color: theme.palette.warning.main,
  },
}))
